import { Box, useTheme } from '@mui/material';
import React from 'react';

interface IProps {
  imageSrc: string;
  alt?: string;
}

const HelpImage = ({ imageSrc, alt = '' }: IProps) => {
  const theme = useTheme();
  return (
    <Box margin='16px 0px' display='flex' justifyContent='center'>
      <Box
        sx={{
          border: `1px solid ${theme.palette.primary.main}`,
          borderRadius: '5px',
          display: 'inline-block',
          maxWidth: '100%',
          padding: '10px',
        }}
      >
        <img
          style={{ maxWidth: '100%' }}
          src={imageSrc}
          alt={alt}
          title={alt}
        ></img>
      </Box>
    </Box>
  );
};

export default HelpImage;
